import { SLR_BOOKING_DETAILS, SLR_BOOKING_RESULT } from '../constants'

export const slrBookingDetailsSuccess = (response) => ({
	type: SLR_BOOKING_DETAILS.SUCCESS,
	response,
})

export const slrBookingDetailsError = (error) => ({
	type: SLR_BOOKING_DETAILS.ERROR,
	error,
})

export const clearSlrBookingDetails = () => ({
	type: SLR_BOOKING_DETAILS.CLEAR,
})

export const setSlrBookingResult = (resultData) => ({
	type: SLR_BOOKING_RESULT.SET,
	resultData,
})

export const clearSlrBookingResult = () => ({
	type: SLR_BOOKING_RESULT.CLEAR,
})
